interface RestoreStateResult {
  [key: string]: any;
  isMatch: boolean;
  constructionId: number;
  menu: string;
  hasQuery: boolean;
  queryString?: string;
}

const restoreState = (url?: string): RestoreStateResult | undefined => {
  const hash = url || location.hash;
  const pattern = /#\/(\d+)\/(\w+)(\?(.+))?/;
  const matches = hash.match(pattern);

  if (!matches) {
    return undefined;
  }

  const [, constructionId, menu, , queryString] = matches;
  const result: RestoreStateResult = {
    isMatch: true,
    constructionId: Number(constructionId),
    menu,
    hasQuery: false,
    queryString,
  };

  if (queryString) {
    result.hasQuery = true;
    parseQueryParameters(queryString, result);
  }

  return result;
};

const parseQueryParameters = (queryString: string, result: RestoreStateResult): void => {
  const params = queryString.split("&");

  params.forEach((param) => {
    const keyValue = param.split("=");

    if (keyValue.length === 2) {
      result[keyValue[0]] = keyValue[1];
    }
  });
};

// URLクエリのうち、p等の特定のパラメータ以外が含まれるかを判定する
export const hasQueryExcept = (urlState: RestoreStateResult | undefined, ignoredKeys: string[] = ["p"]): boolean => {
  const queryString = urlState?.queryString;
  if (!queryString) return false;

  const keys = queryString
    .split("&")
    .map((kv) => kv.split("=")[0])
    .filter((k): k is string => Boolean(k));

  return keys.some((k) => !ignoredKeys.includes(k));
};

export default restoreState;
